import { RoundIconLabelUnit as CommonRoundIconLabelUnit, type RoundIconLabelUnitProps } from '@monorepo/common';

function RoundIconLabelUnit(props: RoundIconLabelUnitProps) {
  return <CommonRoundIconLabelUnit {...props} />;
}

export default RoundIconLabelUnit;
